import { Badge, createTheme, rem } from '@mantine/core'

// 見出し (PageTitle / SectionTitle / 本文見出し) のアクセント用フォント。
// テーマ本文の Noto Sans JP とは別に、見出しにだけ BIZ UDPGothic を当てる。
export const HEADING_FONT = '"BIZ UDPGothic", sans-serif'

export const theme = createTheme({
  primaryColor: 'teal',
  fontFamily: '"Noto Sans JP", sans-serif',
  headings: {
    fontFamily: '"Noto Sans JP", sans-serif',
    fontWeight: '700',
    sizes: {
      h1: { fontSize: rem(34), lineHeight: '1.3' },
      h2: { fontSize: rem(24), lineHeight: '1.35' },
      h3: { fontSize: rem(20), lineHeight: '1.4' },
    },
  },
  defaultRadius: 'md',
  components: {
    // タグ・カテゴリ名を入力どおりに表示する
    Badge: Badge.extend({ defaultProps: { tt: 'none' } }),
  },
})
